module.exports = __webpack_public_path__ + "media/images/icon__point--text@2x-47d96354545e706faa84df1732ec00e7.png";